<template>
    <div class="form-group mb-0 mt-3 p-3">
        
        <b-row>
          <b-col sm="12" md="6" class="mb-3">
            <div class="form-group mb-0 p-2">
              <label>{{ $t('Country') }} <span class="text-danger">*</span></label>
              <Select2 v-model="data.country_code" :options="countryOpt" @select="onSelectCountry($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Country"), disabled:isDisabled}' class="form-control" :class="isDisabled?'disabled':''" :disabled="isDisabled"/>
              <div v-if="error['country_code']" class="invalid-feedback d-block">
                {{$t(error['country_code'])}}
              </div>
            </div>
          </b-col>

          <b-col sm="12" md="6" class="mb-3">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('State') }} <span class="text-danger">*</span></label>
                <Select2 v-model="data.state_code" :options="stateOpt" @select="onSelectState($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("State"), disabled:isDisabled}' class="form-control" :class="isDisabled?'disabled':''" :disabled="isDisabled"/>
                <div v-if="error['state_code']" class="invalid-feedback d-block">
                  {{$t(error['state_code'])}}
                </div>
              </div>
          </b-col>
          
        </b-row>
        <b-row>
          <b-col sm="12" md="6" class="mb-3">
            <div class="form-group mb-0 p-2">
              <label>{{ $t('City') }} <span class="text-danger">*</span></label>
              <input type="text" v-model="data.city_name" name="city_name" value="" :placeholder="$t('City')" class="form-control" @keydown="onChange('city_name')" :class="isDisabled?'disabled':''" :disabled="isDisabled">
              <div v-if="error['city_name']" class="invalid-feedback d-block">
                {{$t(error['city_name'])}}
              </div>
            </div>
          </b-col>
          <b-col sm="12" md="6" class="mb-3">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Postal Code') }} <span class="text-danger">*</span></label>
                <input type="text" v-model="data.postal_code" name="postal_code" value="" :placeholder="$t('Postal Code')" class="form-control" @keydown="onChange('postal_code')" :class="isDisabled?'disabled':''" :disabled="isDisabled">
                <div v-if="error['postal_code']" class="invalid-feedback d-block">
                  {{$t(error['postal_code'])}}
                </div>
              </div>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col sm="12" md="12">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Address Line') }} <span class="text-danger">*</span></label>
                <input type="text" name="addresss" v-model="data.address" class="form-control" :placeholder="$t('Write your address line')" @keydown="onChange('address')" :class="isDisabled?'disabled':''" :disabled="isDisabled"/>
                <div v-if="error['address']" class="invalid-feedback d-block">
                  {{$t(error['address'])}}
                </div>
              </div>
          </b-col>
        </b-row>

        <div class="mt-3">
        <div class="custom-checkbox">
            <input v-model="agree" type="checkbox" autocomplete="off" @change="onChange('agree')" :class="isDisabled?'disabled':''" :disabled="isDisabled">
        </div>
        <label :for="agree" id="agree" class="pl-2">
            {{ $t('Same as profile address') }}
        </label>
        </div>
    </div>
</template>
  
<script>
import Common from '@/services/Common';
import Select2 from 'v-select2-component';
export default {
    data() {
      return {
          publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
          default:{},
          countryOpt:[],
          stateOpt:[],
          agree:'',
          isDisabled:false,
          data:{
            country_code:'',
            state_code:'',
            city_name:'',
            postal_code:'',
            address:'',
            shipping_fee:0
          },
          error:{
              country_code:'',
              state_code:'',
              city_name:'',
              postal_code:'',
              address:''
          }
      }
    },
    components:{
        Select2
    },
    methods:{
        onSelectCountry({id,text}){
          const index = this.countryOpt.findIndex(x => x.id === id);
          this.data.shipping_fee = this.countryOpt[index].fee;
          this.$emit('selected-country',this.data.shipping_fee);

          var self = this;
          this.error.country_code = "";
          self.stateOpt = [];
          if(text){
            this.agree = false;
            this.data.state_code="";
            this.data.city_name="";
            this.data.postal_code="";
            this.data.address="";
          }
          
          Common.states({"country_code":id}).then(response => {
            if(response.status == 200 && response.data.success){
              const state = response.data.data;
              for (let i = 0; i < state.length; i++) {
                self.stateOpt.push({"id":state[i]['id'],"text":state[i]['name']});
              }
            }
          });
        },
        onSelectState({id,text}){
          var self = this;
          this.error.state_code = "";
          
          if(text){
            this.agree = false;
            this.data.city_name="";
            this.data.postal_code="";
            this.data.address="";
          }
        },
        doEscapeMarkup(markup){
          return markup;
        },
        onChange(name){
            this.error[name]="";
            if(name=="agree" && this.agree){
              Object.keys(this.data).forEach((key) => {
                this.error[key] = "";
                this.data[key] = this.default[key];
              });

              if(this.data.country_code){
                this.onSelectCountry({"id":this.data.country_code});
              }
              if(this.data.state_code){
                this.onSelectState({"id":this.data.state_code});
              }
            }
            else if(name!="agree"){
              this.agree=false;
            }
        }
    },
    mounted(){
        var self = this;
        Common.profile().then(response => {
          if(response.status == 200 && response.data.success){
            this.default = response.data.data;
          }
        });

        Common.countries().then(response => {
            if(response.status == 200 && response.data.success){
              const countries=response.data.data;

              for (let i = 0; i < countries.length; i++) {
                  const flag = '<span class="fi fi-'+countries[i]['iso2'].toLowerCase()+'"></span>';  
                  const country_name = "<span>"+countries[i]['name']+"\t\t\t"+"</span>";
                  self.countryOpt.push({"id":countries[i]['iso2'],"text":flag+country_name,"fee":countries[i]['fee']});
              }
            }
        });
    }
}
</script>